import RenderMarkdown from '@components/RTEditor/RenderMarkdown';
import { Paper } from '@material-ui/core';
import { ImageOutlined } from '@material-ui/icons';
import { EventType } from '@src/model/frontendmodel';
import { ChatEvent, ChatEventPayload } from '@types';
import { useEffect, useRef, useState } from 'react';
import { FormattedMessage, FormattedTime } from 'react-intl';
import { styleIncomingMsg } from './ChatEventStyle';
import './instagram-story_style.css';
import MediaResource from './MediaResource';

export type InstagramStoryMessageProps = {
  message: ChatEvent;
};

const InstagramStoryMessage: React.FC<InstagramStoryMessageProps> = ({
  message,
}) => {
  const MAX_HEIGHT_OF_A_LINE = 40;
  const isAutomaticMessage = message?.isAutomaticMessage;
  const deliveryFailed =
    // eslint-disable-next-line no-unneeded-ternary
    message?.payload?.deliveryFailed === undefined ? false : true;
  const messageElementRef = useRef<HTMLDivElement>(null);
  const [isMultiline, setIsMultiline] = useState<boolean>(
    !isAutomaticMessage && !deliveryFailed && !!message?.payload?.mediaType
  );

  let messageFrom =
    message?.type === EventType.INCOMING_MESSAGE.id
      ? 'incoming'
      : message?.type;

  if (message.type === EventType.OUTGOING_MESSAGE.id) {
    messageFrom = !deliveryFailed ? 'outgoing' : 'DELIVERY_FAILED';
    if (message?.isBroadcastWapMsg) messageFrom = 'BROADCAST_MESSAGE';
  }

  useEffect(() => {
    if (!messageElementRef.current) return;
    if (
      !isAutomaticMessage &&
      !deliveryFailed &&
      messageElementRef.current.clientHeight > MAX_HEIGHT_OF_A_LINE
    ) {
      setIsMultiline(true);
    }
  }, [messageElementRef, message, isAutomaticMessage, deliveryFailed]);

  const quotedMessage: ChatEventPayload | undefined =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    message.payload.quotedMessage as any;

  return (
    <div
      ref={messageElementRef}
      className="MessageWrapper"
      data-message-from={messageFrom}
      data-is-multiline={isMultiline}
    >
      <div className="instagram-story">
        <div className="instagram-story__title">
          <FormattedMessage id="ChatEvent.InstagramReplyTitle" />
        </div>
        {quotedMessage?.mediaUrl && (
          <Paper className="instagram-story__media" elevation={0}>
            <MediaResource
              source={quotedMessage.mediaUrl}
              mediaType={quotedMessage.mediaType}
              fallback={
                <div className="instagram-story__fallback">
                  <ImageOutlined style={{ fontSize: '3rem' }} color="inherit" />
                  <FormattedMessage id="ChatEvent.StoryNotAvailable" />
                </div>
              }
            />
          </Paper>
        )}
        {message.payload.text && (
          <Paper className="MessageBox" elevation={0} style={styleIncomingMsg}>
            <RenderMarkdown markdown={message.payload.text} />
            <span className="TimeLbl">
              <FormattedTime
                value={message.payload?.sendingTime}
                hour12
                hour="2-digit"
                minute="2-digit"
              />
            </span>
          </Paper>
        )}
      </div>
    </div>
  );
};

export default InstagramStoryMessage;
